import type { FaireProductEntity } from "../../entity_types/product";

export const p_cjzmk2pdj9: FaireProductEntity = {
  token: "p_cjzmk2pdj9",
  type: "product",
  name: "Woon Mama's Way Hot Sauce",
  brandToken: "b_th428x9zzy",
  brandName: "Woon",
  imageUrl: "https://cdn.faire.com/fastly/446fcfe88d9e1c17df2f9ef043070f738740980d4440510ec57fb6fd7b7bb29a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a3385835834174a07c8e6de8a518c405077342036012be46a57a2b8d5a1a4c0.jpeg",
    "https://cdn.faire.com/fastly/772ad7d2bc33578e43a4a536d45dd5c4f4ad4ab4ba18ff1c28bd9d3b40688619.jpeg",
    "https://cdn.faire.com/fastly/641edaab621a99c99b236cb5a6cd59f47412abab40e3d1da9ce20a7fbfd2d131.jpeg",
    "https://cdn.faire.com/fastly/c3a8cb99ad98468c6aeeb44f0f5069620167371aa35ae50cc9a0c68aa22db21b.jpeg",
    "https://cdn.faire.com/fastly/b6898e85c1cedb1e0ffb4ee527cf1c89a8a4d0fb172eb4f6598a9c7e5554c907.jpeg",
    "https://cdn.faire.com/fastly/7028e9dd3583110cd2cb243ee50991177104e282b5abf37d778b1397ae97f441.jpeg",
    "https://cdn.faire.com/fastly/ffd5a186124a66a5ca399c8122b4bbbdff14392cc47e206c9f7eea3bc8bcc7b2.jpeg",
    "https://cdn.faire.com/fastly/515338a8b95f658356ed6cdcc45e282f87ed129a4e5b0f523bbeef9a6cc4d83b.jpeg",
    "https://cdn.faire.com/fastly/8762ac888a07027813e6f16e061ddf9ead28c9701dd93abdeff831d670b58106.jpeg",
    "https://cdn.faire.com/fastly/9972c4a3bb73ad38b19dd30b7f3b5de6d5c6f5a945b5a03127d1f509852a027c.jpeg"
  ],
  priceDollars: 7.2,
  description: "Mama’s Way is a vegan, gluten-free, and vinegar-based chili garlic hot sauce. You want. It features a fermented Fresno pepper mash, vinegar, and garlic for a very bright and flavorful hot sauce. We use it on everything from Woon noodle dishes and Mama’s Five Spice Chicken Wings to eggs, avocado toast, pizza, soups, tacos, and pretty much anything.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:49.127Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
